import clsx from 'clsx';
import styles from './filter-chip.module.scss';

interface FilterChipProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
  className?: string;
}

/** The mockup's outlined toolbar chip. Supersedes `TopicChip variant="button"`. */
export default function FilterChip({ label, active = false, onClick, className }: FilterChipProps) {
  return (
    <button
      aria-pressed={active}
      className={clsx(styles.chip, active && styles['chip-on'], className)}
      onClick={onClick}
      type="button"
    >
      {label}
    </button>
  );
}
